// provide access to hubspot library
import { HubspotIdentifyData } from '../types/hubspotIdentifyData'

export type HsqClientApi = {
    push: (hubspotIdentifyData: ['identify', HubspotIdentifyData] | ['trackEvent', any]) => void
}

// @ts-ignore
export const _hsq: HsqClientApi = (window._hsq = window._hsq || [])
